import EzController from 'controllers/ez-base-controller';
import {
  sendTrackingEvent,
  trackCompleteEvent,
  findCategoryByElement,
} from 'components/analytics/conversions/tracking';
import { JOIN_PRO_CLICK, JOIN_PRO_COMPLETE } from 'components/analytics/conversions/constants/actions';

export default class UnlockVecteezyController extends EzController {
  track() {
    const category = findCategoryByElement(this.element);

    sendTrackingEvent({
      element: this.element,
      data: {
        action: JOIN_PRO_CLICK,
        category,
      },
    });

    trackCompleteEvent({
      action: JOIN_PRO_COMPLETE,
      category,
    });
  }
}
